export enum ContactTypes {
  ISSUE = 'issue',
  SUGGESTION = 'suggestion',
  QUESTION = 'question'
}

export interface IMessage {
  id?: string;
  message_type: ContactTypes;
  subject: string;
  creation_date?: string;
  text: string;
}

export class Message {
  id?: string;
  message_type!: ContactTypes;
  subject!: string;
  creation_date!: string;
  text!: string;
}
